import { create } from 'zustand';

// The strip lives in the shell but is toggled from the board toolbar, so the flag is shared.
// Independent of the rail: opening a rail panel never opens or closes the strip.
interface FilmstripState {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

export const useFilmstripStore = create<FilmstripState>((set, get) => ({
  open: false,
  toggle: () => set({ open: !get().open }),
  close: () => set({ open: false }),
}));
